import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@perxis-auto/shared";
import { FinanceCalc } from "@perxis-auto/ui-kit/lib/components/FinanceCalc";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import { APP } from "../../../../shared/config/app.js";
import { CURRENCY_MAP } from "../../../../shared/config/credit.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import styles from "./CreditCard.module.scss.js";
const CreditCard = memo(function CreditCard2({ creditData, onClick, priceLabel }) {
  const { t, i18n } = useTranslation(APP.name);
  if (!(creditData == null ? void 0 : creditData.previewProgram)) {
    return null;
  }
  const resolvedProgram = creditData.choice.program ?? creditData.previewProgram;
  const { payment, currency } = resolvedProgram;
  const formattedPrice = formatCurrency(Math.round(Number(payment)), {
    lng: i18n.language,
    hasCurrency: false
  });
  return /* @__PURE__ */ jsx(
    FinanceCalc,
    {
      title: t("widgets.finance.creditCard.title"),
      icon: /* @__PURE__ */ jsx(Icon, { name: "service-credit", sticker: "credit-card-calc-icon", size: 20 }),
      buttonIcon: /* @__PURE__ */ jsx(Icon, { name: "forward", size: 18, sticker: "credit-card-forward-icon" }),
      priceLabel: priceLabel || t("widgets.finance.creditCard.priceLabel"),
      priceValue: `${formattedPrice} ${CURRENCY_MAP[currency || ""] || currency}`,
      buttonLabel: t("widgets.finance.creditCard.buttonLabel"),
      onButtonClick: onClick,
      className: styles.creditCard
    }
  );
});
export {
  CreditCard
};
